import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  TearSheetDataResponse,
  AnalystMoreModelDataResponse,
  AnalystModelDataResponse,
  TrackUserRequestResponse,
  CompanyStatusResponse,
} from "./company-page.model";
import { CompanyPageMeta } from "../store/models/company-page-store.model";

@Injectable({
  providedIn: "root",
})
export class CompanyDataService {
  apiEP: string = window.apiUrl;
  legacyUrl: string = window.caUrl;
  constructor(private http: HttpClient) {}

  getAnalystModelData(ticker: string): Observable<AnalystModelDataResponse> {
    return this.http.get<AnalystModelDataResponse>(
      `${this.apiEP}/api/analyst_models?company=${ticker}`,
    );
  }
  getAnalystModelRowData(params): Observable<AnalystMoreModelDataResponse> {
    return this.http.get<AnalystMoreModelDataResponse>(
      `${this.apiEP}/api/show_more_models_api?company_id=${params.companyId}&source_id=${params.sourceId}&offset=${params.offset}&source_short_name=${params.brokerShortName}`,
    );
  }
  getCompanyMeta(company: string): Observable<CompanyPageMeta> {
    return this.http.get<CompanyPageMeta>(
      `${this.apiEP}/api/company_meta?company=${company}`,
    );
  }

  getTearSheetData(company: string): Observable<TearSheetDataResponse> {
    return this.http.get<TearSheetDataResponse>(
      `${this.apiEP}/api/tear_sheet_data?company=${company}`,
    );
  }

  downloadTearSheet(params: string): Observable<any> {
    return this.http.get(
      `${this.apiEP}/api/prepare_tear_sheet_meta/?&${params}`,
    );
  }

  getLineItemMeta(ticker): Observable<any> {
    return this.http.get(`${this.apiEP}/monitor/get_lim_meta?ticker=${ticker}`);
  }

  getChartRevisionData(ticker, period, dapId, currentQuater): Observable<any> {
    return this.http.get(
      `${this.apiEP}/api/chartrevisiondata?&ticker=${ticker}&periodstart=${period}&dapparamid=${dapId}&depth=default&source=CONSENSUS&revdatatype=1&monitor=true&current_quarter=${currentQuater}`,
    );
  }

  getPreviewDataForSellsideUsers(ticker, period, col): Observable<any> {
    let url = "";
    if (period !== undefined && col !== undefined) {
      url = `${this.apiEP}/api/get_preview_data_for_sell_side_users/?ticker=${ticker}&period=${period}&col_num=${col}`;
    } else {
      url = `${this.apiEP}/api/get_preview_data_for_sell_side_users/?ticker=${ticker}`;
    }
    return this.http.get(`${url}`);
  }
  sendPreviewMailForSellsideusers(data): Observable<any> {
    const jsonData = data;
    return this.http.post(
      `${this.apiEP}/api/send_preview_mail_for_sell_side_users`,
      jsonData,
    );
  }
  getViewModelSrc(params): Observable<any> {
    let url = `/api/model?documentid=${params.documentId}&company=${
      params.companyId
    }&pg=${params.pg}&cut=${params.cut}&downloadType=${
      params.downloadType
    }&source=Filings${
      params.cellId !== undefined ? `&cellId=${params.cellId}` : ``
    }`;
    if (params.is_addin_call) {
      url = `${url}&is_addin_call=${params.is_addin_call}`;
    }
    if (params.ticker) {
      url = `${url}&ticker=${params.ticker}`;
    }
    return this.http.get(`${this.apiEP}${url}`);
  }

  getGuidanceData(params): Observable<any> {
    const options = {
      responseType: "text" as const,
    };
    const url = `/api/get_guidance_filings_document?documentid=${params.documentId}`;
    const result = this.http.get(`${this.apiEP}${url}`, options);
    return result;
  }

  getGuidanceList(params) {
    const url = `/api/get_company_guidance_sentences?documentid=${params.documentId}`;
    return this.http.get(`${this.apiEP}${url}`);
  }

  getPDFFilings(params, options): Observable<any> {
    const url = `/api/pdf_model_filings?documentid=${params.documentId}${
      params.cellId ? `&cellid=${params.cellId}` : ""
    }`;
    return this.http.get(`${this.apiEP}${url}`, options);
  }

  getDuplicateModelData(params): Observable<any> {
    const url = `/api/show_duplicate_models?source_id=${params.sourceId}&transaction_id=${params.transactionId}&model_type=${params.modelType}`;
    return this.http.get(`${this.apiEP}${url}`);
  }

  getCompanyStatusInfo(ticker: string): Observable<CompanyStatusResponse> {
    const url = `${this.apiEP}/api/get_company_info?ticker=${ticker}`;
    return this.http.get<CompanyStatusResponse>(url);
  }

  trackUserRequest(ticker: string): Observable<TrackUserRequestResponse> {
    const url = `${this.apiEP}/api/track_user_request/?ticker=${ticker}&featurename=Prioritize`;
    return this.http.get<TrackUserRequestResponse>(url);
  }
}
